var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowForwardAlt component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowForwardAlt extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.7508 6.54535C16.4579 6.25246 15.983 6.25246 15.6901 6.54535C15.3972 6.83825 15.3972 7.31312 15.6901 7.60601L19.334 11.2499H2.82455C2.42687 11.2499 2.10449 11.5857 2.10449 11.9999C2.10449 12.4141 2.42687 12.7499 2.82455 12.7499H19.3341L15.6901 16.3938C15.3972 16.6867 15.3972 17.1616 15.6901 17.4545C15.983 17.7474 16.4579 17.7474 16.7508 17.4545L21.675 12.5302C21.9679 12.2374 21.9679 11.7625 21.675 11.4696L16.7508 6.54535Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowForwardAlt.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowForwardAlt.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowForwardAlt.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-forward-alt') === undefined) {
    customElements.define('cat-icon-arrow-forward-alt', BlocksIconArrowForwardAlt);
}
